import { defineMessages } from 'react-intl';

export default defineMessages({
  buttonItineraire: {
    id: 'agent.itineraire',
  },
  AgentHoraireTitle: {
    id: 'agent.horaires',
  },
  AgentPhone: {
    id: 'agent.phone',
  },
  AgentLundiJeudi: {
    id: 'agent.lundi_jeudi',
  },
  AgentVendredi: {
    id: 'agent.vendredi',
  },
  AgentSamedi: {
    id: 'agent.samedi',
  },
  AgentEmail: {
    id: 'id_memo.email',
  },
});
